import eventBus from './../../../../common/js/event-bus/event-bus';
import { required } from 'vuelidate/lib/validators';
import email from '../../../../common/js/validators/email';
import { mapActions, mapState } from 'vuex';
import pattern from '../../../../common/js/validators/pattern';
import { NAME_REGEXP } from '../../../../common/js/constants/constants';
import VueInput from '@ui-common/vue-input';
import VueCaptcha from '@ui-common/vue-captcha';
import VueFeedback from '@ui-common/vue-feedback';
import VueErrorMessage from '@ui-common/vue-error-message';

const EMAILBEZAR_TA = 'EMAILBEZAR';
const VEGE_TA = 'VEGE';
const HIBA_TA = 'HIBA';

export default {
	props: {
		modalId: {},
		backendCaptchaError: {},
		displaySuccess: {},
		displayError: {},
		displayForm: {}
	},
	data() {
		return {
			model: {
				address: '',
				name: '',
				captchaKey: null,
				captchaText: null
			},
			captchaError: false
		};
	},
	components: {
		VueInput,
		VueCaptcha,
		VueFeedback,
		VueErrorMessage
	},
	validations() {
		let model = {};
		model.address = { required, email };
		model.name = { required, pattern: pattern(NAME_REGEXP) };
		model.captchaText = this.capthca && this.capthca.htmlFragment ? { required } : {};
		return { model };
	},
	watch: {
		backendCaptchaError(newValue) {
			this.captchaError = newValue;
		}
	},
	methods: {
		submitEmailForm() {
			this.$v.model.$touch();
			if (!this.$v.model.$invalid) {
				this.$emit('on-email-form-post', this.model);
			}
		},
		closePopup(success) {
			eventBus.$emit('closeModal', this.modalId);
			let eventType = EMAILBEZAR_TA + '_' + this.layoutCategory + '_';
			eventType += success ? VEGE_TA : HIBA_TA;
			let taData = {
				eventType,
				dataElements: []
			};
			this.sendTa(taData);
		},
		...mapActions('lahi', ['sendTa', 'resetEmailFormStatus'])
	},
	computed: {
		...mapState('lahi', ['layoutCategory'])
	},
	created() {
		this.$modalEventBus.$on('modal-opened', (modalId) => {
			if (modalId == this.modalId) {
				this.resetEmailFormStatus();
				this.$v.model.$reset();
				this.model = {
					address: '',
					name: '',
					captchaKey: null,
					captchaText: null
				};
				this.$emit('on-modal-opened');
			}
		});
	}
};
